import { BiSliderAlt, FaRegCalendarAlt, FaRegCommentDots, FaRegHandshake, FaRegStar, FaUserMd, FiUsers, GoMegaphone, ImInfo, ImMobile2, IoNewspaperOutline, RiShieldCheckLine } from "react-icons/all";

export const menuItems = [
  {
    name: "dashboard",
    item: [
      {
        id: "Promotion",
        name: "promotion",
        path: "/promotion",
        icon: <GoMegaphone />,
      },
      {
        id: "New Feed",
        name: "news_feed",
        path: "/news-feed",
        icon: <IoNewspaperOutline />,
      },
      {
        id: "Partnership",
        name: "partnership",
        path: "/partnership",
        icon: <FaRegHandshake />,
      },
      {
        id: "Doctors",
        name: "doctor",
        path: "/doctor",
        icon: <FaUserMd />,
      },
    ],
  },
  {
    name: "report",
    item: [
      {
        id: "Report Feedback",
        name: "feedback",
        path: "/report-feedback",
        icon: <FaRegCommentDots />,
      },
      {
        id: "Report Rating",
        name: "rating",
        path: "/report-rating",
        icon: <FaRegStar />,
      },
      {
        id: "Report Appointment",
        name: "appointment",
        path: "/report-appointment",
        icon: <FaRegCalendarAlt />,
      },
    ],
  },
  {
    name: "setting",
    item: [
      {
        id: "Users App",
        name: "user_app",
        path: "/user-app",
        icon: <ImMobile2 />,
      },
      {
        id: "About Us",
        name: "about_us",
        path: "/about-us",
        icon: <ImInfo />,
      },
      {
        id: "Privacy & Terms",
        name: "privacy_terms",
        path: "/privacy-terms",
        icon: <RiShieldCheckLine />,
      },
      {
        id: "System Roles",
        name: "system_role",
        path: "/system-role",
        icon: <BiSliderAlt />,
      },
      {
        id: "User",
        name: "user",
        path: "/user",
        icon: <FiUsers />,
      },
    ],
  },
];
